const EXACT_MESSAGE_MAP = {
  'Invalid credentials': 'Tên đăng nhập hoặc mật khẩu không đúng.',
  'Validation failed': 'Dữ liệu không hợp lệ.',
  'Unauthorized': 'Bạn chưa đăng nhập hoặc phiên đăng nhập đã hết hạn.',
  'Forbidden': 'Bạn không có quyền thực hiện thao tác này.',
  'Internal server error': 'Lỗi hệ thống. Vui lòng thử lại sau.',
  'Login failed': 'Đăng nhập thất bại.',
  'Network Error': 'Không thể kết nối đến máy chủ. Vui lòng kiểm tra mạng.',
};

export const toVietnameseMessage = (message, fallback = 'Có lỗi xảy ra. Vui lòng thử lại.') => {
  if (typeof message !== 'string') return fallback;

  const raw = message.trim();
  if (!raw) return fallback;

  if (EXACT_MESSAGE_MAP[raw]) {
    return EXACT_MESSAGE_MAP[raw];
  }

  const normalized = raw.toLowerCase();

  if (normalized.includes('invalid credential')) {
    return 'Tên đăng nhập hoặc mật khẩu không đúng.';
  }
  if (normalized.includes('validation failed')) {
    return 'Dữ liệu không hợp lệ.';
  }
  if (normalized.includes('unauthorized')) {
    return 'Bạn chưa đăng nhập hoặc phiên đăng nhập đã hết hạn.';
  }
  if (normalized.includes('forbidden')) {
    return 'Bạn không có quyền thực hiện thao tác này.';
  }
  if (normalized.includes('internal server error')) {
    return 'Lỗi hệ thống. Vui lòng thử lại sau.';
  }
  if (normalized.includes('network error')) {
    return 'Không thể kết nối đến máy chủ. Vui lòng kiểm tra mạng.';
  }
  if (normalized.includes('timeout')) {
    return 'Yêu cầu bị quá thời gian chờ. Vui lòng thử lại.';
  }

  return raw;
};

export const normalizeApiErrorMessage = (error, fallback = 'Có lỗi xảy ra. Vui lòng thử lại.') => {
  const apiMessage = error?.response?.data?.error?.message
    || error?.response?.data?.message
    || error?.message;

  return toVietnameseMessage(apiMessage, fallback);
};
